const initEntryForm = () => {
  const stepItems = document.querySelectorAll('.pEntryStep__item')
  const stepLines = document.querySelectorAll('.pEntryStep__line')
  if (!stepItems.length) {
    return
  }

  const updateEntryStep = (step) => {
    let displayStep = step
    if (displayStep === 50) {
      displayStep = 3
    }
    if (displayStep < 1 || displayStep > 3) {
      return
    }

    stepItems.forEach((item, index) => {
      const stepNum = index + 1
      item.classList.toggle('is-current', stepNum <= displayStep)
    })

    stepLines.forEach((line, index) => {
      line.classList.toggle('is-current', displayStep > index + 1)
    })
  }

  const syncEntryStepIndicator = () => {
    const step = typeof window.getEntryFormStep === 'function' ? window.getEntryFormStep() : 1
    updateEntryStep(step)
  }

  if (typeof window.stepShift === 'function') {
    const originalStepShift = window.stepShift
    window.stepShift = function (step) {
      const moved = originalStepShift(step) !== false

      if (moved) {
        updateEntryStep(step)
      }

      return moved
    }
  }

  syncEntryStepIndicator()

  document.addEventListener(
    'wpcf7submit',
    (event) => {
      if (event.detail?.status === 'mail_sent') {
        return
      }

      syncEntryStepIndicator()
    },
    false
  )

  document.addEventListener('wpcf7invalid', syncEntryStepIndicator, false)
}

if (document.querySelector('.js-formArea')) {
  initEntryForm()
}
